import React, { useEffect, useState } from 'react';
import {
  InputContainerPropsSingle,
  Menu,
  MenuItem,
  Typeahead,
} from 'react-bootstrap-typeahead';
import { FormattedDTE } from '@upstart/harmony/lib/legos/dtEntitiesTypes';
import sortBy from 'lodash/sortBy';
import './DTETypeahead.scss';
import classNames from 'classnames';

type Props = {
  dtEntities: FormattedDTE[];
  selectedDTE?: FormattedDTE;
  onChange: InputContainerPropsSingle<FormattedDTE>['onChange'];
  recenterClearButton?: boolean;
  disabled?: boolean;
};

const buildLabels = (option: FormattedDTE) =>
  [option.name, option.cost, option.category].filter(val => val).join(' - ');

export default function DTETypeahead(props: Props) {
  const {
    dtEntities,
    selectedDTE,
    onChange,
    recenterClearButton,
    disabled,
  } = props;

  const [selectedEntity, setSelectedEntity] = useState<FormattedDTE[]>([]);

  useEffect(() => {
    if (!selectedDTE) {
      setSelectedEntity([]);
      return;
    }

    setSelectedEntity([{ ...selectedDTE }]);
  }, [selectedDTE]);

  const classes = classNames('picker', 'dteTypeAhead', { recenterClearButton });

  return (
    <Typeahead
      id="dteTypeAhead"
      size="small"
      className={classes}
      inputProps={{
        shouldSelectHint: (shouldSelect, event) =>
          event.key === 'Enter' || shouldSelect,
      }}
      disabled={disabled}
      clearButton
      selected={selectedEntity}
      options={sortBy(dtEntities, [dte => dte.category, dte => dte.name])}
      filterBy={['name', 'category']}
      labelKey={buildLabels}
      onChange={(selected: FormattedDTE[]) => {
        setSelectedEntity(selected);
        onChange(selected);
      }}
      renderMenu={(results, menuProps) => (
        // we must render the menu ourselves to set the maxHeight prop on the dropdown
        <Menu {...menuProps} maxHeight="120px">
          {results.map((result, index) => (
            <MenuItem option={result} position={index} key={result.id}>
              {buildLabels(result)}
            </MenuItem>
          ))}
        </Menu>
      )}
    />
  );
}
